import React from 'react'
import {createContext} from "use-context-selector";
import {useAppContextState} from "app/@hooks";

const Context = createContext({})

const initialState = { market: null }

export function AppMarketProvider ({children}) {

    const { state, updateState } = useAppContextState(initialState)

    return <Context.Provider value={{state, updateState}}>
        {children}
    </Context.Provider>

}

export default Context